import { Helmet } from "react-helmet"
import {
    Box,
    Button,
    Divider,
    FormControlLabel,
    FormHelperText,
    Grid,
    IconButton,
    Paper,
    Radio,
    RadioGroup,
    TextField,
    Typography
} from "@mui/material"
import React, { useEffect, useMemo } from "react"
import { makeStyles } from "@mui/styles"
import { useTranslation } from "react-i18next"
import { useNavigate, useSearchParams } from "react-router-dom"
import { useSelector, useDispatch } from "react-redux"
import cssVariables from "../../theme/cssVariables"
import * as Util from "../../services/global.service"
// import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import { TimePicker, LocalizationProvider, renderTimeViewClock } from '@mui/x-date-pickers'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3'

import { ReactComponent as EmailIcon } from "../../assets/icons/email.svg"
import { ReactComponent as TimeIcon } from "../../assets/icons/time.svg"
import { ReactComponent as ClockIcon } from "../../assets/icons/clock.svg"
import { ReactComponent as TrashIcon } from "../../assets/images/trash-alt.svg"
import { ReactComponent as PlusCircleIcon } from "../../assets/icons/plus-circle.svg"
import { ReactComponent as AlertRed } from "../../icons/alert-red.svg"

import CustomCheckbox from "../../components/CustomCheckbox"
import RedStarRequired from "../../components/RedStarRequired"

const useStyles = makeStyles({
    disabledSvg: {
        "& > path": {
            stroke: "#A3A3A3",
        },
        "& > circle": {
            stroke: "#A3A3A3",
        }
    },
    trashIconSvg: {
        width: "24px",
        height: "24px",
        "& > path": {
            fill: "#CC6058",
        },
    },
    trashIconDisabledSvg: {
        width: "24px",
        height: "24px",
        "& > path": {
            fill: "#A3A3A3",
        },
    },
    paperRoot: {
        paddingTop: "24px!important",
        paddingBottom: "24px!important",
        paddingLeft: "32px!important",
        paddingRight: "32px!important",
        boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.1)!important",
        borderRadius: "10px!important",
    },
    daysInput: {
        "& .MuiOutlinedInput-root > input": {
            // height: "40px",
            padding: "5px 10px!important",
            fontSize: "16px!important",
            fontWeight: "400!important",
            textTransform: "uppercase"
        }
    },
    daysInputDisabled: {
        "& .MuiOutlinedInput-root > input": {
            // height: "40px",
            padding: "5px 10px!important",
            fontSize: "16px!important",
            fontWeight: "400!important",
            textTransform: "uppercase",
        },
        "& .MuiOutlinedInput-root": {
            background: "#FAFAFA"
        },
        "& .MuiOutlinedInput-root > fieldset": {
            border: "0"
        },
        "& .MuiOutlinedInput-root > input.Mui-disabled": {
            "-webkit-text-fill-color": "#404349"
        }
    },
    timePickerInput: {
        "& .MuiOutlinedInput-root > input": {
            height: "40px",
            padding: "5px 10px!important",
            fontSize: "16px!important",
            fontWeight: "400!important",
            textTransform: "uppercase"
        }
    },
    timePickerInputDisabled: {
        "& .MuiOutlinedInput-root > input": {
            height: "40px",
            padding: "5px 10px!important",
            fontSize: "16px!important",
            fontWeight: "400!important",
            textTransform: "uppercase",
        },
        "& .MuiOutlinedInput-root": {
            background: "#FAFAFA"
        },
        "& .MuiOutlinedInput-root > fieldset": {
            border: "0"
        },
        "& .MuiOutlinedInput-root > input.Mui-disabled": {
            "-webkit-text-fill-color": "#404349"
        }
    },
    timePickerPopper: {
        "& .MuiPaper-root": {
            width: "584px",
            boxShadow: "0px 24px 23px rgba(0, 0, 0, 0.04)"
        },
        "& .PrivatePickersToolbar-root": {
            maxWidth: "unset",
            width: "270px",
            padding: "16px 24px",
        },
        "& .PrivatePickersToolbar-root .PrivateTimePickerToolbar-separator": {
            width: "24px",
            padding: "16px 0",
            fontSize: "48px",
            fontWeight: "700",
            lineHeight: "56px",
            textAlign: "center",
            color: "rgba(0, 0, 0, 0.87)"
        },
        "& .PrivatePickersToolbar-root .MuiTypography-root": {
            // fontSize: "10px",
            // fontWeight: "400",
            // lineHeight: "16px",
            color: "rgba(0, 0, 0, 0.6)"
        },
        "& .PrivatePickersToolbar-root .PrivateTimePickerToolbar-hourMinuteLabel button .MuiTypography-root": {
            width: "96px",
            padding: "16px 0",
            fontSize: "48px",
            fontWeight: "500",
            lineHeight: "56px",
            textAlign: "center",
            background: "rgba(33, 33, 33, 0.08)",
            borderRadius: "4px",
            color: "rgba(0, 0, 0, 0.87)"
        },
        "& .PrivatePickersToolbar-root .PrivateTimePickerToolbar-hourMinuteLabel button .MuiTypography-root.Mui-selected": {
            background: "rgba(93, 161, 150, 0.15)",
            color: "#5DA196"
        },
        "& .PrivateTimePickerToolbar-ampmSelection": {
            border: "1px solid rgba(0, 0, 0, 0.12)",
            borderRadius: "4px",
        },
        "& .PrivateTimePickerToolbar-ampmSelection button:first-child": {
            borderRight: "1px solid rgba(0, 0, 0, 0.12)",
            borderRadius: "0",
        },
        "& .PrivateTimePickerToolbar-ampmSelection .MuiTypography-root": {
            fontSize: "20px",
            padding: "8px 0",
            fontWeight: "500",
            lineHeight: "24px",
            textAlign: "center",
            color: "rgba(0, 0, 0, 0.87)"
        },
        "& .PrivateTimePickerToolbar-ampmSelection .MuiTypography-root.Mui-selected": {
            color: "#5DA196",
            background: "rgba(93, 161, 150, 0.15)",
            width: "100%",
        },
        "& .MuiClockPicker-arrowSwitcher": {
            visibility: "hidden"
        },
        "& div > div > div > .MuiButtonBase-root": {
            visibility: "hidden"
        },
        "& div > .PrivateTimePickerToolbar-hourMinuteLabel > button": {
            visibility: "unset !important"
        },
        "& div > .PrivateTimePickerToolbar-ampmSelection > button": {
            visibility: "unset !important",
            width: "50%",
        },
    }
})

const StyledPaper = (props) => {
    const classes = useStyles();
    return (
        <Paper
            classes={{ root: classes.paperRoot }}
            {...props}
        >
            {props.children}
        </Paper>
    );
}

const ErrorHelper = (props) => {
    const { label } = { ...props }
    const { t } = useTranslation();
    return (
        <Box sx={{ display: "flex", alignItems: "center" }}>
            <AlertRed />
            <FormHelperText
                error={true}
                sx={{ ml: 1, fontSize: "14px", fontWeight: "500" }}
            >
                {label && label !== "" ? label : t("label.pleaseFillOutThisField")}
            </FormHelperText>
        </Box>
    )
}

// time picker schedule component
const TimePickerSchedule = (props) => {
    const classes = useStyles()
    const { t } = useTranslation()
    const { mode, data, setData, isFormChecked, validateData, type } = { ...props }
    const notificationState = useSelector((state) => state.notificationCenter)
    const [inputValidator, setInputValidator] = React.useState([])

    const handleChangeDays = (e, pos = null) => {
        let val = e.target.value
        let tmpScheduleList = [...data]
        val = val.replace(/[^\d]/g, '').replace(/^(?:0+(?=[1-9])|0+(?=0$))/g, "") //prevent characters, special characters and remove leading zero
        if (pos === null) {
            setData([{ days: val, time: tmpScheduleList?.[0]?.time }])
        } else {
            tmpScheduleList = tmpScheduleList.map((item, iIndex) => {
                if (pos === iIndex) {
                    return {
                        ...item,
                        days: val
                    }
                } else {
                    return item
                }
            })
            setData(tmpScheduleList)
        }
        console.log("testing")
    }

    const handleTimeSchedule = (val, pos = null) => {
        let tmpScheduleList = [...data]
        if (pos === null) {
            setData([{ days: tmpScheduleList?.[0]?.days, time: val }])
        } else {
            tmpScheduleList = tmpScheduleList.map((item, iIndex) => {
                if (pos === iIndex) {
                    return {
                        ...item,
                        time: val
                    }
                } else {
                    return item
                }
            })
            setData(tmpScheduleList)
        }
    }

    const handleAddRecurring = () => {
        let currentTmpTimeList = [...data]
        let defaultData = {
            days: "",
            time: new Date(`2023-04-01T07:00:00+07:00`)
        }
        currentTmpTimeList.push(defaultData)
        setData(currentTmpTimeList)
    }

    const handleDelete = (pos) => {
        let currentTmpTimeList = [...data]
        currentTmpTimeList = currentTmpTimeList.filter((_, lIndex) => lIndex !== pos)
        setData(currentTmpTimeList)
    }

    useEffect(() => {
        if (mode !== "schedule") {
            let validate = { days: true, time: true }
            if (data?.[0]?.days === "") {
                validate.days = false
            }
            if (data?.[0]?.time === "") {
                validate.time = false
            }
            setInputValidator(validate)
        } else {
            let tmpValidateArray = []
            let itemValidate = { days: "", time: "" }
            // validate
            data.forEach((item, index) => {
                itemValidate = { days: "", time: "" }
                if (item.days === "") {
                    itemValidate.days = "empty"
                } else {
                    let tmpData = [...data].filter(val => val.days === item.days)
                    let isDup = tmpData.length > 1 ? true : false
                    if (isDup) {
                        itemValidate.days = "duplicate"
                    }
                }
                if (item.time === "") {
                    itemValidate.time = "empty"
                }
                tmpValidateArray.push(itemValidate)
            })
            setInputValidator(tmpValidateArray)
        }
    }, [mode, data])

    useEffect(() => {
        validateData(inputValidator)
    }, [inputValidator])

    if (mode !== "schedule") {
        return (
            <Box sx={{ display: "flex", alignItems: "center", flexDirection: "column", width: "100%" }} {...props}>
                <Grid container mb={1}>
                    <Grid item xs={12} md={5} display="flex" alignItems="center">
                        <Typography fontSize={16} fontWeight={500}>{t('emailNotificationCenter.label.setScheduled')}</Typography>
                        <RedStarRequired />
                    </Grid>
                    <Grid item xs="auto" display="flex" alignItems="center">
                        <Typography fontSize={16} fontWeight={500}>{t('emailNotificationCenter.label.time')}</Typography>
                        <RedStarRequired />
                    </Grid>
                </Grid>
                <Grid container>
                    <Grid item xs={12} md={5} display="flex" alignItems="center" flexDirection="column">
                        <Grid container sx={{ height: "50px" }}>
                            <Grid item xs={12} display="flex" alignItems="center">
                                <Typography fontSize={16} fontWeight={400}>{t('emailNotificationCenter.label.notify')}</Typography>
                                <TextField
                                    id="days"
                                    placeholder={"0"}
                                    size="small"
                                    sx={{
                                        background: "#fff",
                                        width: "100%",
                                        input: { padding: "3px", height: "40px", width: "50px", textAlign: "center" },
                                        width: "50px",
                                        // height: "40px",
                                        mx: "10px",

                                    }}
                                    value={data[0].days}
                                    onChange={(e) => handleChangeDays(e)}
                                    error={notificationState.doValidateNotification && !inputValidator?.days}
                                    disabled={!isFormChecked}
                                    className={isFormChecked ? classes.daysInput : classes.daysInputDisabled}
                                />
                                <Typography fontSize={16} fontWeight={400}>{type === "overdue" ? t('emailNotificationCenter.label.notifyAfterEndDate') : t('emailNotificationCenter.label.notifyBeforeEndDate')}</Typography>
                            </Grid>
                        </Grid>
                        {
                            (notificationState.doValidateNotification && !inputValidator?.days) &&
                            <Grid container mt={1}>
                                <Grid item xs={12}>
                                    <ErrorHelper />
                                </Grid>
                            </Grid>
                        }
                    </Grid>
                    <Grid item xs="auto" display="flex" alignItems="center" flexDirection="column">
                        <Grid container>
                            <Grid item xs="auto" display="flex" alignItems="center">
                                <LocalizationProvider dateAdapter={AdapterDateFns} >
                                    <TimePicker
                                        ampm
                                        minutesStep={5}
                                        slots={{
                                            OpenPickerIcon: ClockIcon
                                        }}
                                        viewRenderers={{
                                            hours: renderTimeViewClock,
                                            minutes: renderTimeViewClock,
                                            seconds: renderTimeViewClock,
                                        }}
                                        showToolbar={true}
                                        orientation="landscape"
                                        value={data[0].time}
                                        onChange={(val) => handleTimeSchedule(val)}
                                        inputProps={{ placeholder: t('admin.inputForm.placeholder.selectTime'), readOnly: true }}
                                        PopperProps={{
                                            className: classes.timePickerPopper
                                        }}
                                        disabled={!isFormChecked}
                                        renderInput={(params) => <TextField {...params} className={isFormChecked ? classes.timePickerInput : classes.timePickerInputDisabled} error={notificationState.doValidateNotification && !inputValidator?.time} />}
                                    />
                                </LocalizationProvider>
                            </Grid>
                        </Grid>
                        {
                            (notificationState.doValidateNotification && !inputValidator?.time) &&
                            <Grid container mt={1}>
                                <Grid item xs={12}>
                                    <ErrorHelper />
                                </Grid>
                            </Grid>
                        }
                    </Grid>
                </Grid>
            </Box>
        )
    } else {
        return <>
            {
                data.map((list, index) => {
                    return (
                        <Box sx={{ display: "flex", alignItems: "center", flexDirection: "column", width: "100%" }} {...props} key={`schedule-${index}`}>
                            <Grid container mb={1}>
                                <Grid item xs={12} md={5} display="flex" alignItems="center">
                                    <Typography fontSize={16} fontWeight={500}>{t('emailNotificationCenter.label.setScheduled')}</Typography>
                                    <RedStarRequired />
                                </Grid>
                                <Grid item xs="auto" display="flex" alignItems="center">
                                    <Typography fontSize={16} fontWeight={500}>{t('emailNotificationCenter.label.time')}</Typography>
                                    <RedStarRequired />
                                </Grid>
                            </Grid>
                            <Grid container>
                                <Grid item xs={12} md={5} display="flex" alignItems="center" flexDirection="column">
                                    <Grid container sx={{ height: "50px" }}>
                                        <Grid item xs={12} display="flex" alignItems="center">
                                            <Typography fontSize={16} fontWeight={400}>{t('emailNotificationCenter.label.notify')}</Typography>
                                            <TextField
                                                id={`schedule-days-${index}`}
                                                key={`schedule-days-${index}`}
                                                placeholder={"0"}
                                                size="small"
                                                sx={{
                                                    background: "#fff",
                                                    width: "100%",
                                                    input: { padding: "3px", height: "40px", width: "50px", textAlign: "center" },
                                                    width: "50px",
                                                    // height: "40px",
                                                    mx: "10px",
                                                }}
                                                value={data[index].days}
                                                onChange={(e) => handleChangeDays(e, index)}
                                                error={notificationState.doValidateNotification && inputValidator?.[index]?.days !== ""}
                                                disabled={!isFormChecked}
                                                className={isFormChecked ? classes.daysInput : classes.daysInputDisabled}
                                            />
                                            <Typography fontSize={16} fontWeight={400}>{type === "overdue" ? t('emailNotificationCenter.label.notifyAfterEndDate') : t('emailNotificationCenter.label.notifyBeforeEndDate')}</Typography>
                                        </Grid>
                                    </Grid>
                                    {
                                        (notificationState.doValidateNotification && inputValidator?.[index]?.days !== "") &&
                                        <Grid container mt={1}>
                                            <Grid item xs={12}>
                                                <ErrorHelper label={inputValidator?.[index]?.days !== "empty" ? t("emailNotificationCenter.label.couldNotBeTheSame") : ""} />
                                            </Grid>
                                        </Grid>
                                    }
                                </Grid>
                                <Grid item xs="auto" display="flex" alignItems="center" flexDirection="column">
                                    <Grid container>
                                        <Grid item xs="auto" display="flex" alignItems="center">
                                            <LocalizationProvider dateAdapter={AdapterDateFns} >
                                                <TimePicker
                                                    ampm
                                                    minutesStep={5}
                                                    slots={{
                                                        OpenPickerIcon: ClockIcon
                                                    }}
                                                    viewRenderers={{
                                                        hours: renderTimeViewClock,
                                                        minutes: renderTimeViewClock,
                                                        seconds: renderTimeViewClock,
                                                    }}
                                                    showToolbar={true}
                                                    orientation="landscape"
                                                    value={data[index].time}
                                                    onChange={(val) => handleTimeSchedule(val, index)}
                                                    inputProps={{ placeholder: t('admin.inputForm.placeholder.selectTime'), readOnly: true }}
                                                    PopperProps={{
                                                        className: classes.timePickerPopper
                                                    }}
                                                    disabled={!isFormChecked}
                                                    renderInput={(params) => <TextField {...params} className={isFormChecked ? classes.timePickerInput : classes.timePickerInputDisabled} error={notificationState.doValidateNotification && inputValidator?.[index]?.time !== ""} />}
                                                />
                                            </LocalizationProvider>
                                            {
                                                mode === "schedule" &&
                                                <IconButton color="primary" aria-label="delete" component="label" sx={{ ml: 1 }} disabled={isFormChecked ? index > 0 ? false : true : true} onClick={() => handleDelete(index)}>
                                                    <TrashIcon className={isFormChecked ? index > 0 ? classes.trashIconSvg : classes.trashIconDisabledSvg : classes.trashIconDisabledSvg} />
                                                </IconButton>
                                            }
                                        </Grid>
                                    </Grid>
                                    {
                                        (notificationState.doValidateNotification && inputValidator?.[index]?.time !== "") &&
                                        <Grid container mt={1}>
                                            <Grid item xs={12}>
                                                <ErrorHelper />
                                            </Grid>
                                        </Grid>
                                    }
                                </Grid>
                            </Grid>
                        </Box>
                    )
                })
            }
            <Box sx={{ display: "flex", mt: 2, width: "100%", justifyContent: "center", alignItems: "center" }}>
                <Button sx={{ textTransform: "none" }} onClick={handleAddRecurring} disabled={!isFormChecked}>
                    <PlusCircleIcon className={!isFormChecked ? classes.disabledSvg : ""} />
                    <Typography sx={{ ml: "10px" }} color={isFormChecked ? "#5DA196" : "#A3A3A3"} fontWeight={500} className="clickable"><u>{t("emailNotificationCenter.label.addRecurring")}</u></Typography>
                </Button>
            </Box>
        </>
    }
}

const RecurringAndTimeSchedule = (props) => {
    const { type, doPreview } = { ...props }
    const classes = useStyles()
    const { t } = useTranslation()
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const notificationState = useSelector((state) => state.notificationCenter)

    const [isFormChecked, setIsFormChecked] = React.useState(false)
    const [timeMode, setTimeMode] = React.useState("recurring")
    const [receiverText, setReceiverText] = React.useState("")
    const [scheduleTimeData, setScheduleTimeData] = React.useState([{
        days: "",
        time: new Date()
    }])
    const [isReceiverString, setIsReceiverString] = React.useState(false)


    const handleFormChecked = (val) => {
        setIsFormChecked(val)
    }

    const handleSetTimeMode = (e) => {
        let val = e.target.value
        setTimeMode(val)
    }

    const handlePreview = () => {
        doPreview(type === "until_end_date" ? "end_date" : "overdue")
    }

    const setData = (data) => {
        if (data?.status === "active") {
            setIsFormChecked(true)
        } else if (data?.status === "inactive") {
            setIsFormChecked(false)
        }

        let tmpReceiverText = notificationState.pageCode && notificationState.pageCode !== "goal" ? "To Manager" : "To Employee"
        setReceiverText(tmpReceiverText)

        if (data?.reminder && Util.testJSON(data?.reminder)) {
            let reminder = JSON.parse(data?.reminder)
            if (reminder?.type) {
                setTimeMode(reminder.type)
            }
            if (reminder?.schedule_time) {
                let resultScheduleTime = []
                let formatTime = new Date()
                reminder.schedule_time.forEach(item => {
                    formatTime = new Date(`2023-04-01T${item.time}+07:00`)
                    resultScheduleTime.push({
                        days: item?.days ?? "",
                        time: formatTime
                    })
                })
                setScheduleTimeData(resultScheduleTime)
            }
        }
    }

    const handleValidator = (data) => {
        let result = true
        let currentType = type === "until_end_date" ? "SET_IS_ENDDATE_FORM_VALID" : "SET_IS_OVERDUE_FORM_VALID"
        if (timeMode === "recurring") {
            if (!data?.days || !data?.time) {
                result = false
            }
        } else if (timeMode === "schedule") {
            data.forEach(item => {
                if (item?.days !== "" || item?.time !== "") {
                    result = false
                }
            })
        }
        dispatch({
            type: currentType,
            payload: result
        })
    }

    // useEffect
    useEffect(() => {
    }, [])


    useEffect(() => {
        if (notificationState?.emailNotification && type) {
            let formData = [...notificationState.emailNotification].find(item => item.feature === type)
            if (typeof formData?.receiver === 'string') {
                setIsReceiverString(true)
            } else {
                setIsReceiverString(false)
            }
            if (formData) setData(formData)
        }
    }, [notificationState.emailNotification, type])

    useEffect(() => {
        if (type === "until_end_date") {
            dispatch({
                type: "SET_DATA_ENDDATE_FORM",
                payload: {
                    feature: type,
                    status: isFormChecked ? "active" : "inactive",
                    reminder: {
                        "type": timeMode,
                        "schedule_time": scheduleTimeData
                    },
                }
            })
        }

        if (type === "overdue") {
            dispatch({
                type: "SET_DATA_OVERDUE_FORM",
                payload: {
                    feature: type,
                    status: isFormChecked ? "active" : "inactive",
                    reminder: {
                        "type": timeMode,
                        "schedule_time": scheduleTimeData
                    },
                }
            })
        }
    }, [type, isFormChecked, timeMode, scheduleTimeData])
    // end useEffect

    return (
        <StyledPaper>
            <Grid container>
                <Grid item xs={6} display="flex" alignItems="center">
                    <CustomCheckbox checked={isFormChecked} onChange={() => handleFormChecked(!isFormChecked)} sx={{ pl: 0 }} />
                    <Typography fontSize={20} fontWeight={600}>{type === "until_end_date" ? t("emailNotificationCenter.label.beforeAndUntilEndTime") : t("emailNotificationCenter.label.afterEndDateTime")}</Typography>
                </Grid>
                <Grid item xs="auto" ml="auto" display="flex" alignItems="center">
                    <Box sx={{ display: "flex", alignItems: "center" }} onClick={() => handlePreview()}>
                        <EmailIcon />
                        <Typography sx={{ ml: "10px" }} color="#5DA196" fontWeight={500} className="clickable"><u>{t("emailNotificationCenter.label.previewEmail")}</u></Typography>
                    </Box>
                </Grid>
            </Grid>
            <Grid container mt="45px">
                <Grid item md={4} xs={12} display="flex" alignItems="flex-start" flexDirection="column">
                    <Typography fontSize={18} fontWeight={500}>{t("emailNotificationCenter.label.receiver")}</Typography>
                    <Typography fontSize={14} fontWeight={400} color="#AAAAAA">{t("emailNotificationCenter.label.receiverDesc")}</Typography>
                </Grid>
                <Grid item xs="auto" display="flex" alignItems="flex-start">
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                        {!isReceiverString ?
                            <RadioGroup
                                aria-labelledby="receive-radio-group"
                                name="radio-buttons-group"
                                defaultValue="responsible"
                            >
                                <FormControlLabel value="1" control={<Radio disabled />} label={receiverText} />
                                <FormControlLabel value="responsible" control={<Radio disabled={!isFormChecked} />} label="To Pending Step Responsible Person" />
                            </RadioGroup>
                            : <Typography fontSize={16} fontWeight={400}>To Pending Step Responsible Person</Typography>
                        }
                    </Box>
                </Grid>
            </Grid>
            <Grid container mt="25px" mb="6px">
                <Grid item xs={12}>
                    <Divider />
                </Grid>
            </Grid>
            <Grid container mt="45px">
                <Grid item md={4} xs={12} display="flex" alignItems="flex-start" flexDirection="column">
                    <Typography fontSize={18} fontWeight={500}>{t("emailNotificationCenter.label.reminderNoti")}</Typography>
                    <Typography fontSize={14} fontWeight={400} color="#AAAAAA" sx={{ maxWidth: "300px" }}>{t("emailNotificationCenter.label.reminderNotiDesc")}</Typography>
                </Grid>
                <Grid item xs={12} md={8} display="flex" alignItems="flex-start" flexDirection="column">
                    <Box sx={{ display: "flex", alignItems: "center", width: "100%" }}>
                        <RadioGroup
                            aria-labelledby="receive-radio-group"
                            name="radio-buttons-group"
                            sx={{ flexGrow: 1 }}
                            value={timeMode}
                        >
                            {/* recurring */}
                            <FormControlLabel value="recurring" control={<Radio disabled={!isFormChecked} sx={{ pt: "1px" }} onChange={handleSetTimeMode} />} label={
                                <>
                                    <Typography>{t("emailNotificationCenter.label.setRecurring")}</Typography>
                                    <Typography fontSize={14} fontWeight={400} color="#AAAAAA">{t("emailNotificationCenter.label.setRecurringDesc")}</Typography>
                                </>
                            } sx={{ display: "flex", alignItems: "flex-start", mb: 2 }} />

                            {
                                timeMode === "recurring" && <TimePickerSchedule sx={{ mb: 1 }} data={scheduleTimeData} setData={setScheduleTimeData} isFormChecked={isFormChecked} validateData={handleValidator} type={type} />
                            }
                            {/* schedule */}
                            <FormControlLabel value="schedule" control={<Radio disabled={!isFormChecked} sx={{ pt: "1px" }} onChange={handleSetTimeMode} />} label={
                                <>
                                    <Typography>{t("emailNotificationCenter.label.setScheduledTime")}</Typography>
                                    <Typography fontSize={14} fontWeight={400} color="#AAAAAA">{t("emailNotificationCenter.label.setScheduledTimeDesc")}</Typography>
                                </>
                            } sx={{ display: "flex", alignItems: "flex-start" }} />
                            {
                                timeMode === "schedule" &&
                                <TimePickerSchedule mode="schedule" data={scheduleTimeData} setData={setScheduleTimeData} isFormChecked={isFormChecked} validateData={handleValidator} type={type} />
                            }
                        </RadioGroup>
                    </Box>
                </Grid>
            </Grid>
        </StyledPaper>
    )
}
export default RecurringAndTimeSchedule
